import ActivitiesFormatter from './ActivitiesFormatter.vue';
import Formatter from 'src/class/Formatter';
import i18n from 'src/i18n';
import RatesFormatter from './RatesFormatter.vue';

const configTable = () => {
  const tableColumns = [
    {
      prop: 'activity.code',
      label: i18n.t('common_words.code'),
      minWidth: 100,
      sortable: true,
      toShow: false,
      show: true,
    },
    {
      prop: 'activity.name',
      label: i18n.t('common_words.activity'),
      minWidth: 200,
      sortable: true,
      toShow: false,
      show: true,
    },
    {
      prop: 'activity.name',
      label: i18n.t('common_words.activity'),
      toShow: true,
      show: false,
      formatter: ActivitiesFormatter,
    },
    {
      prop: 'price',
      label: i18n.t('labor.unit_value_dollarsign'),
      minWidth: 150,
      sortable: true,
      align: 'center',
      formatter: (row, column) => {
        return Formatter.formatNumber(Number(row[column.property]));
      },
    },
    {
      prop: 'activity.activity_unit_payment.name',
      label: i18n.t('labor.unit'),
      minWidth: 120,
      sortable: true,
      formatter: (row) => {
        return `${row.activity ? row.activity.activity_unit_payment.name : ''}
        (${
          row.activity ? row.activity.activity_unit_payment.abbreviation : ''
        })`;
      },
    },
    {
      prop: 'start_date',
      label: i18n.t('common_words.starting_date_f'),
      minWidth: 150,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'extra_hours',
      label: i18n.t('labor.hours_extra'),
      minWidth: 120,
      sortable: true,
      align: 'center',
      formatter: (row, column) => {
        return Number(row[column.property]) === 0
          ? i18n.t('common_words.no')
          : `${i18n.t('common_words.yes')} - ${Number(
              row['number_extra_hours']
            )} ${i18n.t('labor.hours_extra')}`;
      },
    },
    {
      prop: 'rate_types',
      label: i18n.t('labor.rate_additional'),
      toShow: true,
      show: false,
      formatter: RatesFormatter,
    },
  ];

  return { tableColumns };
};

export default configTable;
